(function () {
  'use strict';

  /* @ngdoc object
   * @name lib
   * @description
   *
   */
  angular
    .module('lib', []);
}());
